import PropTypes from "prop-types";
import { capitalizeFirstLetterOfEachWord } from "../../../utils/commons";
import MatchKeywordsViewComponent from "./MatchKeywordsViewComponent";
import "./keywordGroupsQuantityView.scss";

const KeywordGroupsQuantityView = ({ data }) => {
  const groups = Array.isArray(data?.groups) ? data.groups : [];

  if (!groups.length) {
    return (
      <div className="additional-fields-container">
        <span className="field-value">-</span>
      </div>
    );
  }

  return (
    <div className="keyword-groups-quantity-view w-100">
      {groups.map((group, index) => (
        <div
          key={`${group.filter_by}-${index}`}
          className="keyword-groups-quantity-group"
          data-testid="keyword-groups-quantity-group"
        >
          <div className="additional-fields-container">
            <div className="field-pair">
              <span className="field-label">
                {`Group ${index + 1} (${capitalizeFirstLetterOfEachWord(group.filter_by || "")}):`}
              </span>
            </div>
            <div className="field-pair-two-column">
              <span className="field-value">
                {`Quantity threshold: ${group.quantity_threshold ?? "-"}`}
              </span>
            </div>
          </div>
          <MatchKeywordsViewComponent
            data={{ ids: group.ids }}
            filterBy={group.filter_by}
          />
        </div>
      ))}
    </div>
  );
};

KeywordGroupsQuantityView.propTypes = {
  data: PropTypes.shape({
    groups: PropTypes.arrayOf(
      PropTypes.shape({
        filter_by: PropTypes.string,
        ids: PropTypes.arrayOf(PropTypes.string),
        quantity_threshold: PropTypes.number,
      })
    ),
  }),
};

export default KeywordGroupsQuantityView;
